// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"a35da22d","989":"69c4fb63"}[chunkId] + ".chunk.js";
};